if (!window.Eurus.loadedScript.has('main-collection-product-grid-visual.js')) {
  window.Eurus.loadedScript.add('main-collection-product-grid-visual.js');

  requestAnimationFrame(function () {
    function reflowMasonry(grid) {
      if (!grid || !grid.classList.contains('cpv-masonry')) return;
      grid.style.columnCount = '';
      void grid.offsetWidth;
      grid.style.removeProperty('column-count');
    }

    function bindImages(grid) {
      grid.querySelectorAll('.cpv-image').forEach(function (img) {
        if (img.dataset.mcpgvBound === 'true') return;
        img.dataset.mcpgvBound = 'true';
        if (img.complete) return;
        img.addEventListener('load', function () {
          reflowMasonry(grid);
        }, { once: true });
      });
    }

    function bindGrid(grid) {
      if (!grid || grid.dataset.mcpgvObserved === 'true') return;
      grid.dataset.mcpgvObserved = 'true';
      bindImages(grid);

      var observer = new MutationObserver(function () {
        bindImages(grid);
        reflowMasonry(grid);
      });
      observer.observe(grid, { childList: true, subtree: true });

      if (typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(function () {
          reflowMasonry(grid);
        });
        resizeObserver.observe(grid);
      }
    }

    function initMasonry(root) {
      (root || document).querySelectorAll('.mcpgv-section .cpv-masonry').forEach(bindGrid);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('.mcpgv-section .cpv-masonry').forEach(reflowMasonry);
      }, 120);
    });

    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        document.querySelectorAll('.mcpgv-section .cpv-masonry').forEach(reflowMasonry);
      }, 200);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initMasonry();
      });
    } else {
      initMasonry();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initMasonry(event.target);
    });
  });
}
